import { render } from "./ModalWrapper.vue?vue&type=template&id=f53e6a08&scoped=true&ts=true"
import script from "./ModalWrapper.vue?vue&type=script&lang=ts"
export * from "./ModalWrapper.vue?vue&type=script&lang=ts"

import "./ModalWrapper.vue?vue&type=style&index=0&id=f53e6a08&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f53e6a08"]])

export default __exports__